import { BenefitsExtensionBanner } from '@lyrahealth-inc/ui-core-crossplatform/src/molecules/benefitsExtensionBanner/BenefitsExtensionBanner'

import RacialStressBanner from '../../features/microsite/components/Banners/RacialStressBanner'

export const BANNERS = {
  RACE: {
    component: RacialStressBanner as $TSFixMe,
    paths: ['/secure/index/search-care', '/secure/onboard'],
  },
  BENEFITS_EXTENSION: {
    component: BenefitsExtensionBanner,
    paths: [],
  },
}
